import { TableColumn } from "react-data-table-component";

import { DeliveryStatus } from "../types";

type FetchParams = {
  uuid: string;
  tstamp?: string;
  apiUrl?: string;
};
export async function fetchDeliveryStatus({
  uuid,
  tstamp,
  apiUrl = "https://cuanto.app",
}: FetchParams): Promise<DeliveryStatus> {
  const url = tstamp
    ? `${apiUrl}/orders/${uuid}/delivery_status?status_at=${tstamp}`
    : `${apiUrl}/orders/${uuid}/delivery_status`;

  const res = await fetch(url);
  return await res.json();
}

// Utility function for working with DataTable
export function cols<T>(list: [string, keyof T][]): TableColumn<T>[] {
  return list.map(
    ([name, key]) => ({ name, selector: (r) => r[key] } as TableColumn<T>)
  );
}
